import initSentry from "@config/sentry.config";
import { remult } from "remult";

export function env(app: "user" | "admin" | "server", mode: string): void;
export function env(
  app: "weme-app",
  mode: string,
  isCapacitor: boolean,
  myIp: string,
): void;
export function env(
  app: (typeof ENV)["app"],
  mode: string,
  isCapacitor?: boolean,
  myIp?: string,
) {
  const prodServerUrl = "https://www.we-me.app";
  const stagingServerUrl = "https://staging-marketplace-ac171702f639.herokuapp.com";
  const developmentServerUrl = `http://localhost:3002`;
  const developmentCapacitorUrl = `http://${myIp}:3002`;

  let serverBaseUrl: string;

  if (mode === "production") {
    serverBaseUrl = prodServerUrl;
  } else if (mode === "staging") {
    serverBaseUrl = stagingServerUrl;
  } else if (mode === "development") {
    if (app === "weme-app" && isCapacitor) {
      serverBaseUrl = developmentCapacitorUrl;
    } else if (app === "admin") {
      // Vite dev server (port 3000) proxies /rpc, /api, /static, /socket.io → backend :3002
      serverBaseUrl = "http://localhost:3000";
    } else {
      serverBaseUrl = developmentServerUrl;
    }
  } else {
    throw new Error(`Invalid mode: ${mode}`);
  }

  if (app !== "server") {
    initSentry(app, mode);

    //TODO: remove this when remult is gone
    remult.apiClient.url = `${serverBaseUrl}/api`;
  }

  globalThis.ENV = {
    mode: mode as any,
    app,
    serverBaseUrl,
    isBackend: app === "server",
    isFrontEnd: app !== "server",
  };

  if (mode === "development") {
    console.debug("ENV", globalThis.ENV);
  }
}
